export default __webpack_public_path__ + "static/media/ao.54d2f3fa.svg";